import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h3" component="h1" gutterBottom>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
                The page you are looking for does not exist or has been moved.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/dashboard')} sx={{ mt: 2 }}>
                Back to Dashboard
            </Button>
        </Box>
    );
};

export default NotFound;
